//
/**
 *
 * This is the entry point of the IBE webapp. Here polyfill handling for legacy browsers as well as work around for google translate gets started and app initialisation is triggered.
 *
 * What happens?
 * 1 - Preparation: First the initialisation-trigger-function is created, which basically just imports and runs the "appInit module" when called.
 *     Note that this is just a function which will be passed as an argument in the next step. So it is not called yet.
 * 2 - Running: The legacy browser polyfill loader (which loads the heavy polyfills in case they are needed) as well as google translate workaround loader is called.
 *     We provide the script from the preparatory step 1 as a parameter to the enhancedBrowserWorkArounds function which is a composition of both polyfill loader as well google translate
 *     workaround.
 *
 * Note, that we cannot rely on Promises at this point, as they will be polyfilled later
 *
 * @author Manuel Dugué <manuel.dugue@comvel.de> and Vishwajeet Srivastava <vishwajeet.srivastava@lastminute.com>
 */
import './polyfills'
import 'react-app-polyfill/ie11'
import {
  loadLegacyBrowserPolyfillsIfNeededAndInitialize,
  loadGoogleTranslateWorkaround,
} from './legacyBrowserPolyfillsAndWorkArounds'
import { compose } from 'redux'

// step 1: the initialisation-trigger-function. It is called as part of step 2 below.
const initialize = () =>
  import(/* webpackChunkName: 'appInit' */ './appInit').then(app =>
    app.default()
  )

// step 2: starting the workarounds for browsers including polyfill and google translate workaround

const enhancedBrowserWorkArounds = compose(
  loadLegacyBrowserPolyfillsIfNeededAndInitialize,
  loadGoogleTranslateWorkaround
)

enhancedBrowserWorkArounds(initialize)
